<script setup lang="ts">
defineProps<{
  title: string;
  value: string | number;
}>();
</script>

<template>
  <div class="badge-stats-card">
    <div class="stats-content">
      <div class="stats-value">
        {{ value }}
      </div>
      <div class="stats-title">
        {{ title }}
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.badge-stats-card {
  @include q-card-10;
  padding: var(--Spacing-spacing-6);
  background: var(--Neutral-UI-neutral-ui-10);
  display: flex;
  flex-direction: column;
  gap: var(--Spacing-spacing-4);
  flex: 1;
  min-width: 0;
}

.stats-content {
  display: flex;
  flex-direction: column;
  gap: var(--Spacing-spacing-1);

  .stats-value {
    @include font-metric-lg;
    color: var(--Neutral-UI-neutral-ui-100);
  }

  .stats-title {
    @include font-body-sm-bold;
    color: var(--Neutral-UI-neutral-ui-60);
  }
}
</style>
